import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Round: React.FC<SVGProps<SVGSVGElement>> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="5.5" fill="#356DFF" stroke="#E2F0FF" />
    </svg>
  )
}

Round.displayName = 'Round'

export default withIcon(Round)
